export function loadModulorReactCSS() {
  const VERSION = '__MODULOR_VERSION__';

  if (typeof window !== 'undefined') {
    const globalKey = '__modulor_css_versions__';

    if (!window[globalKey]) {
      window[globalKey] = {};
    }

    const isDarkTheme = window.matchMedia('(prefers-color-scheme: dark)').matches;
    if (!window[globalKey][VERSION]) {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = `https://mdlr.tech/react/${VERSION.replaceAll('.', '_')}-index.css`;
      document.head.appendChild(link);

      window[globalKey][VERSION] = true;

      console.log(
        `%c@modulor/react%c Loaded CSS for version%c ${VERSION}`,
        'color: white; background: #4CAF50; padding: 2px 6px; border-radius: 4px;',
        `${isDarkTheme ? 'color: #fff;' : 'color: #000;'}`,
        'color: #388E3C; font-weight: bold;',
      );
    } else {
      console.log(
        `%c@modulor/react%c CSS for version%c ${VERSION}%c already loaded. Skipping.`,
        'color: white; background: #FF9800; padding: 2px 6px; border-radius: 4px;',
        `${isDarkTheme ? 'color: #fff;' : 'color: #000;'}`,
        'color: #F57C00; font-weight: bold;',
        `${isDarkTheme ? 'color: #fff;' : 'color: #000;'}`,
      );
    }
  }
}
